import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAntiguaAndBarbuda = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_838)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 12.822 0.082875 13.6246 0.240328 14.4L12 15.1305L23.7597 14.4C23.9172 13.6246 24 12.822 24 12C24 11.1781 23.9171 10.3755 23.7597 9.60001L12 8.86955L0.240328 9.60001C0.082875 10.3755 0 11.1781 0 12H0Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.7597 14.4H0.240326C1.35215 19.8773 6.19457 24 12 24C17.8054 24 22.6478 19.8773 23.7597 14.4Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.240326 9.6H23.7598C22.6478 4.12266 17.8055 0 12 0C6.19448 0 1.35215 4.12266 0.240326 9.6Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 9.6H6.78262L8.9145 8.59716L7.77923 6.53255L10.0942 6.97528L10.3876 4.63673L12 6.35676L13.6125 4.63673L13.9057 6.97528L16.2208 6.53255L15.0856 8.59725L17.2174 9.6Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 18.6274 5.37262 24 12 24L2.39981 4.79958C0.893062 6.80531 0 9.29826 0 12Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 9.29826 23.1069 6.80531 21.6002 4.79958L12 24Z",
				fill: "#A2001D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_838",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAntiguaAndBarbuda;
